export const alertLevels = {
  ERROR: 'ERROR', // intended for end-users, always visible
  WARN: 'WARN', // extra visibility intended only for internal builds
  // NONE: 'NONE',
} as const;

// export const { ERROR, WARN } = alertLevels;
